var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-28"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"green"}}),_vm._v("\n  Processing payment...\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }